<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div class="col-lg-3 aos-init aos-animate text-center d-none d-lg-block mx-auto resume-content" data-aos="fade-right fade-left" data-aos-delay="100" >
          <div class="card resume-content float-right">
            <div class="card-header"><img src="/media/img/mask-resume.svg" alt=""></div>
            <div class="card-body">
              <div class="card-text">
                <span>Nombre Empresa</span> <p class="text-truncate">{{client.nombreEmpresa}}</p>
              </div>
              <div class="card-text">
                <span>RUT empresa</span> <p>{{client.rutEmpresa}}-{{client.rutEmpresaDv}}</p>
              </div>
              <div class="card-text">
                <span>Correo Corporativo</span> <p class="text-truncate">{{client.email}}</p>
              </div>
             
            </div>
          </div>
        </div>
        <div v-if="order==null || order.enRegulacion==0" class="col-md-12 col-lg-9 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
          <h3>Pago No realizado</h3>
          <div class="row card card-row d-flex flex-row ">
            <div class="row d-flex flex-row mb-0 justify-items-between  align-items-start">
              <div class="col-2 text-center p-0">
                <i class="fa fa-times-circle text-danger"></i>
              </div>
                      <div class="col-10">
                        <p>Lo sentimos. La operación no pudo ser procesada. Esto se puede deber a alguno de los siguientes motivos:<br/>
                         Ha ingresado información incorrecta al momento de confirmar el pago<br/>
                        Algun documento no está disponible para ser pagado en línea
                        
                        </p>
              </div>
            </div>
        </div>
        </div>


        <div v-if="order.enRegulacion==1"  class="col-md-12 col-lg-9 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
          <h3>Pago en Proceso</h3>
          <div class="row card card-row d-flex flex-row ">
            <div class="row d-flex flex-row mb-0 justify-items-between  align-items-start">
              <div class="col-2 text-center p-0">
                <i class="fa fa-info-circle text-information"></i>
              </div>
                      <div class="col-10">
                        <p>Hemos recibido su pago correctamente<br/>
                        En estos momentos nos encontramos procesando y actualizando su información. En unos minutos recibirá un correo electrónico con el comprobante de pago.
                        <br/>
                        
                        </p>
              </div>
            </div>
        </div>
        </div>
       
        
      </div>
     
    <!--end::Dashboard-->
</template>


<script>

import { mapState } from "vuex";
import { GET_ORDER, GET_PDF, SEND_PDF } from "@/core/services/store/payment.module";
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import {Money} from 'v-money'

import moment from 'moment'
moment.locale( 'es' );

export default {
  name: "comprobante",
  components: {},
  data() {
    return {
      loading: false,
      order:{numeroTransaccion:0, enRegulacion:0},
      email:null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      }
    };
  },
  mounted () {
    this.getOrder();
  },
  methods: {
    getOrder() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_ORDER, this.$route.query.codigo)
          .then((response)=>{this.order = response,this.$Progress.finish()});
    },
    sendVoucher() {
      const t = this;
      this.$Progress.start();
      this.$store
          .dispatch(SEND_PDF, {tokenOrden : this.order.tokenOrden, email : this.order.email})
          .then(function(){
            t.$Progress.finish()
          });
    },
    getPdf() {
      this.loading=true;
      const t = this;
      this.$Progress.start();
      this.$store
          .dispatch(GET_PDF, this.order.tokenOrden)
          .then(function(response){
            t.document = response;
            t.$Progress.finish()
            setTimeout(function()
              {
                console.log(t.document.data);
                var blob = new Blob([t.document], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.setAttribute('href', URL)
                link.href = url;
                
                link.setAttribute("download", "comprobante.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                t.loading=false;
              }, 0);
          });
    },
    
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  computed: {
    ...mapState({
      details : state => state.payment.details,
      errors: state => state.errors,
      client: state => state.auth.user,
      rutCliente: function(){
        return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
      },  
    })
  }
};
</script>
<style>
.b-form-datepicker {min-width:130px;}
.b-form-datepicker label {
        padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full{width:100%;}
</style>
